import React from 'react';
import style from './style.module.scss';
import Icon from '@components/icon-component';
import AuthService from '@services/auth.service';
import { useNavigate } from 'react-router';
import Modal from '@components/modal';

const LoginExpiredModal = ({ open, setOpen }) => {
  if (!open) {
    return <></>;
  }
  const navigate = useNavigate();

  const closedModal = () => {
    setOpen(false);
  };

  const refreshModalIcon = <Icon name={'key-icon'} />;
  const statusText = <>Login expired</>;
  const modalTextUpper = (
    <>
      <span>It’s been quite a while since you logged in.</span>
      <br />
      <br />
      <span className={style.light}>
        For security reasons, you’ll need to <span className={style.dark}>log out</span> and{' '}
        <span className={style.dark}>log back in</span> before you can refresh data or sync tasks.
      </span>

      <br />
      <br />
      <span className={`${style.light} ${style.red}`}>
        Until then, you can continue to work in Oplii Mobile.
      </span>
    </>
  );

  const modalInnerBody = (
    <div>
      <div className={style.modalBtn}>
        <button
          className="btn-fill button-large modal-btn-height"
          onClick={() => {
            AuthService.logout({ clearCache: false });
            navigate('/');
            setOpen(false);
          }}
        >
          LOG OUT
        </button>
      </div>
    </div>
  );

  return (
    <Modal
      open={open}
      setOpen={() => closedModal()}
      icon={refreshModalIcon}
      statusText={statusText}
      modalTextUpper={modalTextUpper}
      modalImageClassName={style.modalImage}
      textBtn={'Maybe later'}
      progressData={'Ensure your internet connection is stable before logging out.'}
      modalTextUpperClass={style.modalTextUpper}

      //   progressDataColor={'#F26531'}
    >
      {modalInnerBody}
    </Modal>
  );
};

export default LoginExpiredModal;
